import { WEB_URL, BACKEND_ROOT_URL } from "../api";

export const getProfileSelfieImageUrls = images => {
  let main = null;
  const others = [];

  for (const img of images) {
    if (img.type === 1 || img.type === 31) {
      main = img;
    } else if (img.type === 2 || img.type === 32) {
      others.push(img);
    }
  }

  const buildUrl = img => {
    if (!img?.hash) return null;
    const ext = img?.extension === "png" ? "jpg" : img?.extension;
    return ext
      ? `${BACKEND_ROOT_URL}/api/v1/media/profile/${img.hash}.${ext}`
      : `${BACKEND_ROOT_URL}/api/v1/media/profile/${img.hash}`;
  };

  return {
    main: buildUrl(main),
    first: buildUrl(others[0]),
    second: buildUrl(others[1]),
  };
};

export const getProfileSelfieImageMeta = (images) => {
  let main = null;
  const others = [];

  for (const img of images) {
    if (img.type === 1 || img.type === 31) {
      main = img;
    } else if (img.type === 2 || img.type === 32) {
      others.push(img);
    }
  }

  const buildImageObject = (img) => {
    if (!img?.hash) return null;
    const ext = img.extension === "png" ? "jpg" : img.extension;
    const url = ext
      ? `${BACKEND_ROOT_URL}/api/v1/media/profile/${img.hash}.${ext}`
      : `${BACKEND_ROOT_URL}/api/v1/media/profile/${img.hash}`;

    return {
      id: img.id,
      type: img.type,
      src: url,
    };
  };

  return {
    main: main ? buildImageObject(main) : null,
    first: others[0] ? buildImageObject(others[0]) : null,
    second: others[1] ? buildImageObject(others[1]) : null,
  };
};


export const getProfileMainFullImage = image => {
  if (!image?.hash) {
    return `${WEB_URL}/assets/user.png`; // fallback
  }

  const ext = image?.extension === "png" ? "jpg" : image?.extension;
  return ext
    ? `${BACKEND_ROOT_URL}/api/v1/media/avatar/${image.hash}.${ext}`
    : `${BACKEND_ROOT_URL}/api/v1/media/avatar/${image.hash}`;
};

export const getProfileImageUrl = image => {
  if (!image?.hash) {
    return `${WEB_URL}/assets/user.png`; // fallback
  }

  const ext = image?.extension === "png" ? "jpg" : image?.extension;
  return ext
    ? `${BACKEND_ROOT_URL}/api/v1/media/avatar/${image.hash}.${ext}`
    : `${BACKEND_ROOT_URL}/api/v1/media/avatar/${image.hash}`;
};
